// Routine actions, dispatched on boot...

export const GET_CATEGORIES = 'GET_CATEGORIES'
export const GET_CATEGORIES_LOADING = 'GET_CATEGORIES_LOADING'
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS'
export const GET_CATEGORIES_FAILURE = 'GET_CATEGORIES_FAILURE'
export const getCategories = () => ({
  type: GET_CATEGORIES,
})

export const GET_DISTRICTS = 'GET_DISTRICTS'
export const GET_DISTRICTS_LOADING = 'GET_DISTRICTS_LOADING'
export const GET_DISTRICTS_SUCCESS = 'GET_DISTRICTS_SUCCESS'
export const GET_DISTRICTS_FAILURE = 'GET_DISTRICTS_FAILURE'
export const getDistricts = () => ({
  type: GET_DISTRICTS,
})



// WEBPACK FOOTER //
// ./src/actions/routine.js